import React from "react";
import "./massage.css";

export interface propsMassage {
	type?: "ok" | "err";
	text?: string;
}

const Massage = (msg: propsMassage) => {
	if (typeof msg.text === "string") {
		if (msg.text.length > 0) {
			return (
				<>
					<div className={`stylesMassage `}>
						<p className={`massageText ${msg.type}`}>{msg.text}</p>
					</div>
				</>
			);
		}
	}
	return null;
};

export default Massage;
